import * as React from 'react';
import { Menu, MenuItem, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import HistoryIcon from '@mui/icons-material/History';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { useTranslation } from 'react-i18next';
import { pushToast, useDispatch } from '../../state';
import { openEditPackingSlipModal } from '../../state/packingSlipModalSlice';
import client from '../../util/api-client';
import { TRPCClientError } from '@trpc/client';
import { serverError } from '../modals/constants/errors';

interface RowButtonProps {
  packingSlip: any;
}

export default function RowButton(props: RowButtonProps) {
  const { t: tCS } = useTranslation([], {
    keyPrefix: 'team.Components.PackingSlipsBrowseTable',
  });
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    handleClose();
    dispatch(
      openEditPackingSlipModal({
        packingSlipIdToEdit: props.packingSlip.id,
      }),
    );
  };

  const handleOpenPDF = async () => {
    setAnchorEl(null);
    document.body.style.cursor = 'wait';

    try {
      const pdfBase64 = await client.getPackingSlipPDF.query(
        props.packingSlip.id,
      );

      const binary = atob(pdfBase64);
      const array = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) {
        array[i] = binary.charCodeAt(i);
      }

      const blob = new Blob([array], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
    } catch (error) {
      console.error('error', error);
      if (error instanceof TRPCClientError) {
        dispatch(pushToast({ message: error.message, type: 'error' }));
      } else {
        dispatch(pushToast({ message: serverError, type: 'error' }));
      }
    } finally {
      document.body.style.cursor = 'default';
    }
  };

  const OptionsMUIIconSize = 20;

  return (
    <div>
      <IconButton
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        className="text-2xl tracking-tight border-0 rounded-full"
      >
        <MoreHorizIcon />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={handleEdit} style={{ color: 'rgb(51, 99, 255)' }}>
          <EditIcon style={{ fontSize: OptionsMUIIconSize }} />
          {tCS('Edit')}
        </MenuItem>
        <MenuItem onClick={handleOpenPDF} style={{ color: 'rgb(51, 99, 255)' }}>
          <PictureAsPdfIcon style={{ fontSize: OptionsMUIIconSize }} />
          &nbsp; View PDF
        </MenuItem>
        <MenuItem onClick={handleClose} style={{ color: 'rgb(51, 99, 255)' }}>
          <HistoryIcon style={{ fontSize: OptionsMUIIconSize }} />
          {tCS('View History')}
        </MenuItem>
        <MenuItem onClick={handleClose} style={{ color: 'rgb(51, 99, 255)' }}>
          <DeleteIcon style={{ fontSize: OptionsMUIIconSize }} />
          {tCS('Delete')}
        </MenuItem>
      </Menu>
    </div>
  );
}
